import React, { useEffect, useState } from 'react';
import { Bookmark } from 'lucide-react';
import { getConfig } from '../config';
import { useContent } from '../contexts/ContentContext';

export default function BookmarkCount({ imageId }: { imageId: number }) {
    const { t } = useContent();
    const [result, setResult] = useState<{ id: number; count: number } | null>(null);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        const refresh = (event: Event) => {
            const detail = (event as CustomEvent).detail;
            if (String(detail?.imageId) === String(imageId) && detail?.action === 'bookmark') setAttempt(value => value + 1);
        };
        window.addEventListener('image-score-changed', refresh);
        return () => window.removeEventListener('image-score-changed', refresh);
    }, [imageId]);
    useEffect(() => {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 5000);
        setResult(null);
        fetch(`${getConfig().apiHost}/score_api.php?id=${imageId}&bookmarks=1`, { signal: controller.signal })
            .then(async response => {
                if (!response.ok) throw new Error('Bookmark lookup failed');
                const data = await response.json();
                if (!Number.isSafeInteger(data.bookmark_count) || data.bookmark_count < 0) throw new Error('Invalid bookmark count');
                if (!controller.signal.aborted) setResult({ id: imageId, count: data.bookmark_count });
            }).catch(() => { if (!controller.signal.aborted) setResult(null); })
            .finally(() => window.clearTimeout(timeout));
        return () => { controller.abort(); window.clearTimeout(timeout); };
    }, [imageId, attempt]);
    if (result?.id !== imageId || result.count < 1) return null;
    return <span className="lab-bookmark-count flex items-center gap-1 mt-1 text-sm" data-bookmark-count={result.count}>
        <Bookmark size={16} aria-hidden="true" />{t('detail.bookmarkCount', { count: result.count })}
    </span>;
}
